module.exports = __webpack_public_path__ + "static/img/miniqrcode.eed374cb.jpg";